import { Cookies } from 'react-cookie'
import { loginOrRegisterWithAlmaTunnus } from '../../api/api'
import {
  displayNotificationModal,
  displayAlmaTunnusVerificationModal,
} from '../../components/modal/modalActions'
import {
  setUserProfile,
  setLoggedInUser,
  afterLoginRefresh,
  TEMP_PROFILE_COOKIE_NAME,
} from '../userActions'
import { logException } from '../../sentry'
import config from '../../../config/config'
import {
  selectUserAlmaIdHash,
  selectUserEmail,
  selectUserHash,
  selectUserId,
  selectUserName,
} from '../../selectors/userSelector'

export const REGISTER_ALMA_ACCOUNT = 'REGISTER_ALMA_ACCOUNT'

export const LOGIN_ALMA_USER = 'LOGIN_ALMA_USER'
export const LOGIN_ALMA_USER_SUCCESS = 'LOGIN_ALMA_USER_SUCCESS'
export const LOGIN_ALMA_USER_FAILURE = 'LOGIN_ALMA_USER_FAILURE'

export const LOGOUT_ALMA_USER = 'LOGOUT_ALMA_USER'
export const LOGOUT_ALMA_USER_SUCCESS = 'LOGOUT_ALMA_USER_SUCCESS'
export const LOGOUT_ALMA_USER_FAILURE = 'LOGOUT_ALMA_USER_FAILURE'

export const ALMA_LOGIN_NOTIFICATION = 'ALMA_LOGIN_NOTIFICATION'

/**
 * Kick off the process of manually logging a user through AlmaTunnus.
 * This will redirect user to login page and upon successfull login
 * redirect back to site and login to ampparit profile.
 */
export function loginAlmaTunnus() {
  return dispatch => {
    dispatch({
      type: LOGIN_ALMA_USER,
    })
  }
}


/**
 * Kick off the process of logging user out of AlmaTunnus.
 * @note Logging out of AlmaTunnus alone is not enough. If ampparit user session is not
 * cleared via call to /api/logout/, the user remains fully logged in to ampparit.com.
 * Due to this, AlmaTunnus logout will even not trigger for as long as ampparit user is
 * logged in. So you must also call `dispatch(logoutAmpparit())` if the user is logged in.
 */
export function logoutAlmaTunnus() {
  return dispatch => {
    dispatch({
      type: LOGOUT_ALMA_USER,
    })
  }
}

export function registerAlmaTunnus() {
  return dispatch => {
    dispatch({
      type: REGISTER_ALMA_ACCOUNT,
    })
  }
}


/**
 * Login to ampparit profile with the information received from a successful
 * AlmaTunnus login.
 */
export function setAlmaTunnusUser(accessToken, emailVerified) {
  return dispatch => {
    dispatch({
      type: LOGIN_ALMA_USER_SUCCESS,
      emailVerified,
    })

    if (!emailVerified) {
      dispatch(displayAlmaTunnusVerificationModal())
      return
    }

    const cookies = new Cookies()
    const tempProfile = cookies.get(TEMP_PROFILE_COOKIE_NAME)

    return loginOrRegisterWithAlmaTunnus(accessToken, tempProfile)
      .then(response => {
        dispatch(loginUser(response))
      })
      .catch(error => {
        logException(error)
        dispatch(displayNotificationModal(
          `Tapahtui virhe '${error.message}'. Yritä ladata sivu uudestaan. Ota yhteyttä ylläpitoon ampparit@ampparit.com mikäli virhe toistuu`,
          'Kirjautumisessa tuli ongelma'
        ))
        dispatch({
          type: LOGIN_ALMA_USER_FAILURE,
          error,
        })
      })
  }
}


/**
 * Update ampparit user and profile state with data from
 * login (or migrate or register) response.
 */
function loginUser(response) {
  return (dispatch, getState) => {
    const { jwt, id, email, name, userHash, almaIdHash, profile } = response.data

    // No jwt returned means login failed
    if (!jwt) return

    // Sometimes we are logging in a user that is already logged in. This happens
    // on initial page view, if SSR was already made with the user's profile data.
    // We want to avoid unnecessary state updates that would cause network fetches
    // and user interface rerenders.
    const state = getState()
    const oldId = selectUserId(state)
    const oldName = selectUserName(state)
    const oldEmail = selectUserEmail(state)
    const oldHash = selectUserHash(state)
    const oldAlmaIdHash = selectUserAlmaIdHash(state)
    if (id !== oldId || name !== oldName || email !== oldEmail || userHash !== oldHash || almaIdHash !== oldAlmaIdHash) {
      dispatch(setLoggedInUser(id, name, email, profile, userHash, almaIdHash, jwt))
      dispatch(setUserProfile(profile))
      dispatch(afterLoginRefresh())
      dispatch(showLoginNotification(email))
    }

    new Cookies().remove(TEMP_PROFILE_COOKIE_NAME, config.cookieOptions)
  }
}

/**
 * Show login notification for the given email.
 */
function showLoginNotification(email) {
  return dispatch => {
    dispatch({
      type: ALMA_LOGIN_NOTIFICATION,
      email,
    })
  }
}
